import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "includes"
})
export class IncludesPipe implements PipeTransform {
    public transform<T>(array: T[], value: T): boolean {
        return array.includes(value);
    }
}
